import { render, staticRenderFns } from "./yiJianKaiPiao.vue?vue&type=template&id=40a81bd8&scoped=true&"
import script from "./yiJianKaiPiao.vue?vue&type=script&lang=js&"
export * from "./yiJianKaiPiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a81bd8",
  null
  
)

export default component.exports